document.onreadystatechange = function () {
  let $ = window.jQuery
  
  $(document).ready(() => {
    /* $('button[aria-controls="mobile-menu-4"]').attr('aria-expanded', true) */                
  })
  let init = () => {
    /* $('img.product-item__secondary-image.variant-images').hide() */
  
    // show init variant
    const els = document.querySelectorAll('.product-item__image-wrapper.product-item__image-wrapper--multiple > a')


    for (const el of els) {
      var observer = new MutationObserver(function(mutations) {
        //console.log('change')
        const productId = $($(el).parent().parent().find('#product-id'))?.attr('data-product-id')
        //console.log(productId)
        const variantId = $(el).attr('href')?.split('variant=')?.[1]
       /*
       $(`img[data-product-id="${productId}"]`).hide()
        $(`img[data-variant-id="${variantId}"]`).show()
      */
    });
    observer.observe(el, { 
      attributes: true, 
      attributeFilter: ['href'] });                 
    }
  }
  
  init()
  setTimeout(() => { init()} , 1500)
}
